import { Button } from '@lt/components';
import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from '@lt/localization';
import { CLIENT_DATA_ID } from 'src/routes/Checkout/store/constants/tourists';
import Client from '../Client';
import type { PropsFromRedux } from '.';
import { TEST_ID_CLIENT_DATA, TEST_ID_CLIENT_DATA_BUTTON } from './constants';

interface IProps extends PropsFromRedux {
  isHotelOnly: boolean;
  setIsMailConfirmOpened?: (value: boolean) => void;
}

export const ClientDataBanner = ({
  name,
  surname,
  phone,
  email,
  isMobile,
  isLoggedIn,
  unconfirmedPhone,
  isHotelOnly,
  setIsMailConfirmOpened,
}: IProps) => {
  const { t } = useTranslation();
  const clientDataTitle = t('checkout.client');
  const [showClientDataChange, setShowClientDataChange] = useState(false);

  useEffect(() => {
    // Для авторизации через Тбанк, который не отдает нам почту
    if (!email && isLoggedIn) {
      setShowClientDataChange(true);
      if (setIsMailConfirmOpened) {
        setIsMailConfirmOpened(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email, isLoggedIn]);

  const closeOpenShortForm = () => {
    setShowClientDataChange(false);
    if (setIsMailConfirmOpened) {
      setIsMailConfirmOpened(false);
    }
  };

  return (
    <>
      <SubTitle $isHotelOnly={isHotelOnly}>{clientDataTitle}</SubTitle>

      {showClientDataChange || !isLoggedIn || unconfirmedPhone ? (
        <Client openShortForm={closeOpenShortForm} />
      ) : (
        <StyledClientDataBanner
          isMobile={isMobile}
          data-testid={TEST_ID_CLIENT_DATA}
          id={CLIENT_DATA_ID}
        >
          <Section>
            <Title>
              <span>{t('checkout.registrationForm.name.header')} </span>
              <span>{t('checkout.registrationForm.surname.header')}</span>
            </Title>
            <ClientDataItem>{`${name} ${surname}`}</ClientDataItem>
          </Section>
          <Section>
            <Title>{t('checkout.registrationForm.phone.header')}</Title>
            <ClientDataItem>{phone}</ClientDataItem>
          </Section>
          <Section>
            {/*  eslint-disable-next-line i18next/no-literal-string */}
            <Title>Email</Title>
            <ClientDataItem>{email}</ClientDataItem>
          </Section>
          <ChangeDataButton
            $isMobile={isMobile}
            onClick={() => setShowClientDataChange(true)}
            data-testid={TEST_ID_CLIENT_DATA_BUTTON}
          >
            {t('checkout.registrationForm.changeDataButton')}
          </ChangeDataButton>
        </StyledClientDataBanner>
      )}
    </>
  );
};

const SubTitle = styled.div<{ $isHotelOnly: boolean }>`
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  margin-bottom: 8px;
  ${({ $isHotelOnly }) =>
    $isHotelOnly &&
    css`
      margin-top: 22px;
    `}
`;

const Title = styled.div`
  color: var(--grey1);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
`;

const Section = styled.div``;

const StyledClientDataBanner = styled.div<{ isMobile: boolean }>`
  ${({ isMobile }) =>
    isMobile
      ? css`
          ${Section} {
            display: flex;
            margin-bottom: 8px;
          }
          ${Title} {
            width: 120px;
          }
          ${SubTitle} {
            font-size: 18px;
          }
        `
      : css`
          display: flex;
          justify-content: space-between;
          ${SubTitle} {
            font-size: 22px;
          }
        `}
  background: var(--white);
  padding: 20px 16px;
  border-radius: var(--border-radius);
  width: 100%;
`;

const ChangeDataButton = styled(Button).attrs({ size: 'none' })<{
  $isMobile: boolean;
}>`
  display: flex;
  justify-content: center;
  padding: 12px 16px;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  ${({ $isMobile }) =>
    $isMobile &&
    css`
      width: 100%;
    `}
`;

const ClientDataItem = styled.div`
  color: var(--black);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
`;

export default ClientDataBanner;
